module.exports = __webpack_public_path__ + "static/media/Icona-7.407ae235.svg";